/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Show_Marker_CommentsInputs */

const en_options_editor_show_marker_comments = /** @type {(inputs: Options_Editor_Show_Marker_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Marker Comments`)
};

const fr_options_editor_show_marker_comments = /** @type {(inputs: Options_Editor_Show_Marker_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les commentaires des marqueurs`)
};

const de_options_editor_show_marker_comments = /** @type {(inputs: Options_Editor_Show_Marker_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marker-Kommentare anzeigen`)
};

const it_options_editor_show_marker_comments = /** @type {(inputs: Options_Editor_Show_Marker_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra commenti del marcatore`)
};

const ru_options_editor_show_marker_comments = /** @type {(inputs: Options_Editor_Show_Marker_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать комментарии к маркеру`)
};

const es_options_editor_show_marker_comments = /** @type {(inputs: Options_Editor_Show_Marker_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar comentarios del marcador`)
};

const zh_cn2_options_editor_show_marker_comments = /** @type {(inputs: Options_Editor_Show_Marker_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示标记评论`)
};

const ja_options_editor_show_marker_comments = /** @type {(inputs: Options_Editor_Show_Marker_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーコメントを表示`)
};

const hi_options_editor_show_marker_comments = /** @type {(inputs: Options_Editor_Show_Marker_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर टिप्पणियाँ दिखाएँ`)
};

const pt_pt2_options_editor_show_marker_comments = /** @type {(inputs: Options_Editor_Show_Marker_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar comentários do marcador`)
};

/**
* | output |
* | --- |
* | "Show Marker Comments" |
*
* @param {Options_Editor_Show_Marker_CommentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_show_marker_comments = /** @type {((inputs?: Options_Editor_Show_Marker_CommentsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Show_Marker_CommentsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_show_marker_comments(inputs)
	if (locale === "de") return de_options_editor_show_marker_comments(inputs)
	if (locale === "it") return it_options_editor_show_marker_comments(inputs)
	if (locale === "ru") return ru_options_editor_show_marker_comments(inputs)
	if (locale === "es") return es_options_editor_show_marker_comments(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_show_marker_comments(inputs)
	if (locale === "ja") return ja_options_editor_show_marker_comments(inputs)
	if (locale === "hi") return hi_options_editor_show_marker_comments(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_show_marker_comments(inputs)
	return en_options_editor_show_marker_comments(inputs)
});